import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import ActionCreator from "../../../store/actions/index";
import { Marker, Tooltip } from "react-leaflet";
import Leaflet from "leaflet";
import { typeWarning } from "../../../utils/staticData";
import { getRoutesOfType } from "../../../utils/helpers";
import t from "../../../languages/pl";
import iconInfo from "../../../images/mapPins/infoPin.png";
import iconDanger from "../../../images/mapPins/dangerPin.png";
import iconWarning from "../../../images/mapPins/warningPin.png";
import moment from 'moment-timezone';
import { displayDateTimeFormat } from './../../../utils/staticData';

const evaluateIcon = type => {
    switch(type.toLowerCase()) {
        case "info":
            return iconInfo;
        case "warning":
            return iconWarning;
        case "danger":
            return iconDanger;
        default:
            return iconDanger;
    }
};

const icon = type => new Leaflet.icon({
    iconUrl: evaluateIcon(type),
    iconSize: [50, 50],
    iconAnchor: [25, 50]
});


const drawMarkers = (elements) => {
    if (!Array.isArray(elements))
        elements = [elements];
    return elements.map(marker => {
        return (
            <Marker
                key={marker.id}
                icon={icon(marker.typ)}
                position={[marker.lat, marker.lon]}
                zIndexOffset={1200}
            >
                <Tooltip
                    direction="top"
                    offset={new Leaflet.point(0, -50)}
                    className="toyotaFont"
                >
                    {t.incident}:&nbsp;{marker.zdarzenie}
                    <br />
                    {t.date}:&nbsp;{moment.unix(marker.data).format(displayDateTimeFormat)}
                </Tooltip>
            </Marker>
        );
    });
};

const WarningMarker = props => {
    const { selectedRoutes, warningsFilter } = props;
    const [visibleMarkers, setMarkers] = useState([]);

    useEffect(() => {
        if(!selectedRoutes || !Array.isArray(selectedRoutes) || selectedRoutes.length === 0)
            return setMarkers([]);
        let selectedWarnings = getRoutesOfType(selectedRoutes, typeWarning);
        selectedWarnings = selectedWarnings.filter(warning => warning.selected === true);
        setMarkers(selectedWarnings);
        // props.fitInBounds();
    }, [selectedRoutes, warningsFilter]);

    return (
        <Fragment>
            {drawMarkers(visibleMarkers)}
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        selectedRoutes: state.mapRoutesReducer.selectedRoutes,
        warningsFilter: state.filterReducer.warnings,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WarningMarker);

WarningMarker.propTypes = {
    selectedRoutes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    fitInBounds: PropTypes.func.isRequired,
    warningsFilter: PropTypes.bool
};